import type { AxiosError } from 'axios';

import { useMembersContext } from '@/contexts/membersContext';
import type { Organization } from '@/types/organization';
import type PaginatedResponse from '@/types/paginatedResponse';
import { PaginationParams } from '@/types/pagination';
import type RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';
import logAjaxError from '@/utils/logAjaxError';

export type OrganizationsParams = PaginationParams & {
  search?: string;
  referrer_code?: string;
};

export const organizationRepository = {
  async getOrganizations({
    host,
    params
  }: {
    host: string;
    params: OrganizationsParams;
  }): Promise<RepositoryResponse<PaginatedResponse<Organization[]>>> {
    try {
      const path = `/api/organizations/`;
      const response = await ajax.get({ url: `${host}${path}`, params: { ...params } });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);
      return defaultRepositoryError(error as AxiosError, 'Failed to get organizations.');
    }
  }
};

const OrganizationRepository = () => {
  const { host } = useMembersContext();

  return {
    async getOrganizations(
      params: OrganizationsParams
    ): Promise<RepositoryResponse<PaginatedResponse<Organization[]>>> {
      return organizationRepository.getOrganizations({ host, params });
    }
  };
};

export default OrganizationRepository;
